module.exports = __webpack_public_path__ + "static/img/305.638f28d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210427/305.jpg
// module id = XgQX
// module chunks = 0